import type { DemographicQuestion, JobPost } from "../../types/jben/job_post";
import type { DemographicQuestionAnswer } from "../../types/jben/application";
import type { DemographicAnswer } from "./build_application";

export const isDemographicDataConsentRequired = (
  jobPost: JobPost,
  demographicAnswers: DemographicQuestionAnswer[] | DemographicAnswer[][],
) => {
  const { demographic_questions } = jobPost;
  return (
    anyDemographicQuestionRequired(demographic_questions?.questions) ||
    anyDemographicQuestionAnswered(demographicAnswers)
  );
};

export const anyDemographicQuestionRequired = (demographicQuestions?: DemographicQuestion[]) => {
  if (!demographicQuestions) return false;
  return demographicQuestions.some((q) => q.required);
};

export const anyDemographicQuestionAnswered = (
  demographicAnswers: DemographicQuestionAnswer[] | DemographicAnswer[][],
) => {
  return demographicAnswers.some((answer) => {
    if ("answer_options" in answer) {
      return answer.answer_options.length > 0;
    } else {
      const filtered = answer.filter((a) => a.freeform === undefined || a.freeform !== "");
      return filtered.length > 0;
    }
  });
};
